export type { GuideInstalledPositionFormProps } from './guide-installed-position-form';
export { default as GuideInstalledPositionForm, default } from './guide-installed-position-form';
